/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type MultiVehicleGroupAssignmentCreate,
    MultiVehicleGroupAssignmentCreateFromJSON,
    MultiVehicleGroupAssignmentCreateToJSON,
} from '../models/MultiVehicleGroupAssignmentCreate';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type VehicleGroupAssignment,
    VehicleGroupAssignmentFromJSON,
    VehicleGroupAssignmentToJSON,
} from '../models/VehicleGroupAssignment';
import {
    type VehicleGroupAssignmentCreate,
    VehicleGroupAssignmentCreateFromJSON,
    VehicleGroupAssignmentCreateToJSON,
} from '../models/VehicleGroupAssignmentCreate';
import {
    type VehicleGroupAssignmentSortKey,
    VehicleGroupAssignmentSortKeyFromJSON,
    VehicleGroupAssignmentSortKeyToJSON,
} from '../models/VehicleGroupAssignmentSortKey';
import {
    type VehicleGroupAssignmentUpdate,
    VehicleGroupAssignmentUpdateFromJSON,
    VehicleGroupAssignmentUpdateToJSON,
} from '../models/VehicleGroupAssignmentUpdate';

export interface VehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRequest {
    multiVehicleGroupAssignmentCreate: MultiVehicleGroupAssignmentCreate;
}

export interface VehicleGroupAssignmentsCreateVehicleGroupAssignmentRequest {
    vehicleGroupAssignmentCreate: VehicleGroupAssignmentCreate;
}

export interface VehicleGroupAssignmentsDeleteVehicleGroupAssignmentRequest {
    vehicleGroupAssignmentId: string;
}

export interface VehicleGroupAssignmentsListVehicleGroupAssignmentsRequest {
    pageSize: number;
    vehicleGroupIds?: Array<string> | null;
    vehicleId?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleGroupAssignmentSortKey;
}

export interface VehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRequest {
    pageSize: number;
    vehicleGroupIds?: Array<string> | null;
    vehicleId?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleGroupAssignmentSortKey;
}

export interface VehicleGroupAssignmentsReadVehicleGroupAssignmentRequest {
    vehicleGroupAssignmentId: string;
}

export interface VehicleGroupAssignmentsUpdateVehicleGroupAssignmentRequest {
    vehicleGroupAssignmentId: string;
    vehicleGroupAssignmentUpdate: VehicleGroupAssignmentUpdate;
}

export interface VehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRequest {
    vehicleGroupAssignmentCreate: VehicleGroupAssignmentCreate;
}

export interface VehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRequest {
    vehicleGroupAssignmentId: string;
    vehicleGroupAssignmentUpdate: VehicleGroupAssignmentUpdate;
}

/**
 * VehicleGroupAssignmentsApi - interface
 * 
 * @export
 * @interface VehicleGroupAssignmentsApiInterface
 */
export interface VehicleGroupAssignmentsApiInterface {
    /**
     * Creates request options for vehicleGroupAssignmentsCreateMultipleVehicleGroupAssignments without sending the request
     * @param {MultiVehicleGroupAssignmentCreate} multiVehicleGroupAssignmentCreate 
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRequestOpts(requestParameters: VehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRequest): Promise<runtime.RequestOpts>;

    /**
     * This endpoint accepts a list of `Vehicle` ids and `VehicleGroup` ids respectively.  Assignments are then created for each `Vehicle` to each `VehicleGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * @summary Create multiple `VehicleGroupAssignment`s
     * @param {MultiVehicleGroupAssignmentCreate} multiVehicleGroupAssignmentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRaw(requestParameters: VehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleGroupAssignment>>>;

    /**
     * This endpoint accepts a list of `Vehicle` ids and `VehicleGroup` ids respectively.  Assignments are then created for each `Vehicle` to each `VehicleGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * Create multiple `VehicleGroupAssignment`s
     */
    vehicleGroupAssignmentsCreateMultipleVehicleGroupAssignments(requestParameters: VehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleGroupAssignment>>;

    /**
     * Creates request options for vehicleGroupAssignmentsCreateVehicleGroupAssignment without sending the request
     * @param {VehicleGroupAssignmentCreate} vehicleGroupAssignmentCreate 
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsCreateVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsCreateVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new vehicle group assignment.
     * @summary Create a vehicle group assignment
     * @param {VehicleGroupAssignmentCreate} vehicleGroupAssignmentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsCreateVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsCreateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroupAssignment>>;

    /**
     * Create a new vehicle group assignment.
     * Create a vehicle group assignment
     */
    vehicleGroupAssignmentsCreateVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsCreateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroupAssignment>;

    /**
     * Creates request options for vehicleGroupAssignmentsDeleteVehicleGroupAssignment without sending the request
     * @param {string} vehicleGroupAssignmentId 
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsDeleteVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsDeleteVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the vehicle group assignment with the given ID.
     * @summary Delete a vehicle group assignment
     * @param {string} vehicleGroupAssignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsDeleteVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsDeleteVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the vehicle group assignment with the given ID.
     * Delete a vehicle group assignment
     */
    vehicleGroupAssignmentsDeleteVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsDeleteVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for vehicleGroupAssignmentsListVehicleGroupAssignments without sending the request
     * @param {number} pageSize 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {string} [vehicleId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleGroupAssignmentSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsListVehicleGroupAssignmentsRequestOpts(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the vehicle group assignment present.
     * @summary List vehicle group assignment
     * @param {number} pageSize 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {string} [vehicleId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleGroupAssignmentSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsListVehicleGroupAssignmentsRaw(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleGroupAssignment>>>;

    /**
     * Lists all the vehicle group assignment present.
     * List vehicle group assignment
     */
    vehicleGroupAssignmentsListVehicleGroupAssignments(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleGroupAssignment>>;

    /**
     * Creates request options for vehicleGroupAssignmentsListVehicleGroupAssignmentsMetadata without sending the request
     * @param {number} pageSize 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {string} [vehicleId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleGroupAssignmentSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRequestOpts(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Vehicle group assignment listing metadata
     * @param {number} pageSize 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {string} [vehicleId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleGroupAssignmentSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRaw(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle group assignment listing metadata
     */
    vehicleGroupAssignmentsListVehicleGroupAssignmentsMetadata(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for vehicleGroupAssignmentsReadVehicleGroupAssignment without sending the request
     * @param {string} vehicleGroupAssignmentId 
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsReadVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsReadVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the vehicle group assignment specified by the given ID.
     * @summary Get a single vehicle group assignment
     * @param {string} vehicleGroupAssignmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsReadVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsReadVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroupAssignment>>;

    /**
     * Returns the vehicle group assignment specified by the given ID.
     * Get a single vehicle group assignment
     */
    vehicleGroupAssignmentsReadVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsReadVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroupAssignment>;

    /**
     * Creates request options for vehicleGroupAssignmentsUpdateVehicleGroupAssignment without sending the request
     * @param {string} vehicleGroupAssignmentId 
     * @param {VehicleGroupAssignmentUpdate} vehicleGroupAssignmentUpdate 
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsUpdateVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsUpdateVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the vehicle group assignment specified by the given ID.
     * @summary Update vehicle group assignment
     * @param {string} vehicleGroupAssignmentId 
     * @param {VehicleGroupAssignmentUpdate} vehicleGroupAssignmentUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsUpdateVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsUpdateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroupAssignment>>;

    /**
     * Update the vehicle group assignment specified by the given ID.
     * Update vehicle group assignment
     */
    vehicleGroupAssignmentsUpdateVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsUpdateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroupAssignment>;

    /**
     * Creates request options for vehicleGroupAssignmentsValidateCreateVehicleGroupAssignment without sending the request
     * @param {VehicleGroupAssignmentCreate} vehicleGroupAssignmentCreate 
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new vehicle group assignment without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a vehicle group assignment
     * @param {VehicleGroupAssignmentCreate} vehicleGroupAssignmentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new vehicle group assignment without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle group assignment
     */
    vehicleGroupAssignmentsValidateCreateVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignment without sending the request
     * @param {string} vehicleGroupAssignmentId 
     * @param {VehicleGroupAssignmentUpdate} vehicleGroupAssignmentUpdate 
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given vehicle group assignment, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate vehicle group assignment update
     * @param {string} vehicleGroupAssignmentId 
     * @param {VehicleGroupAssignmentUpdate} vehicleGroupAssignmentUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleGroupAssignmentsApiInterface
     */
    vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given vehicle group assignment, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle group assignment update
     */
    vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class VehicleGroupAssignmentsApi extends runtime.BaseAPI implements VehicleGroupAssignmentsApiInterface {

    /**
     * Creates request options for vehicleGroupAssignmentsCreateMultipleVehicleGroupAssignments without sending the request
     */
    async vehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRequestOpts(requestParameters: VehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['multiVehicleGroupAssignmentCreate'] == null) {
            throw new runtime.RequiredError(
                'multiVehicleGroupAssignmentCreate',
                'Required parameter "multiVehicleGroupAssignmentCreate" was null or undefined when calling vehicleGroupAssignmentsCreateMultipleVehicleGroupAssignments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_group_assignments/multi`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MultiVehicleGroupAssignmentCreateToJSON(requestParameters['multiVehicleGroupAssignmentCreate']),
        };
    }

    /**
     * This endpoint accepts a list of `Vehicle` ids and `VehicleGroup` ids respectively.  Assignments are then created for each `Vehicle` to each `VehicleGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * Create multiple `VehicleGroupAssignment`s
     */
    async vehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRaw(requestParameters: VehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleGroupAssignment>>> {
        const requestOptions = await this.vehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VehicleGroupAssignmentFromJSON));
    }

    /**
     * This endpoint accepts a list of `Vehicle` ids and `VehicleGroup` ids respectively.  Assignments are then created for each `Vehicle` to each `VehicleGroup`. Trying to create duplicate assignments won\'t lead to errors and will simply be ignored.
     * Create multiple `VehicleGroupAssignment`s
     */
    async vehicleGroupAssignmentsCreateMultipleVehicleGroupAssignments(requestParameters: VehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleGroupAssignment>> {
        const response = await this.vehicleGroupAssignmentsCreateMultipleVehicleGroupAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleGroupAssignmentsCreateVehicleGroupAssignment without sending the request
     */
    async vehicleGroupAssignmentsCreateVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsCreateVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupAssignmentCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupAssignmentCreate',
                'Required parameter "vehicleGroupAssignmentCreate" was null or undefined when calling vehicleGroupAssignmentsCreateVehicleGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_group_assignments/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleGroupAssignmentCreateToJSON(requestParameters['vehicleGroupAssignmentCreate']),
        };
    }

    /**
     * Create a new vehicle group assignment.
     * Create a vehicle group assignment
     */
    async vehicleGroupAssignmentsCreateVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsCreateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroupAssignment>> {
        const requestOptions = await this.vehicleGroupAssignmentsCreateVehicleGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleGroupAssignmentFromJSON(jsonValue));
    }

    /**
     * Create a new vehicle group assignment.
     * Create a vehicle group assignment
     */
    async vehicleGroupAssignmentsCreateVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsCreateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroupAssignment> {
        const response = await this.vehicleGroupAssignmentsCreateVehicleGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleGroupAssignmentsDeleteVehicleGroupAssignment without sending the request
     */
    async vehicleGroupAssignmentsDeleteVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsDeleteVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupAssignmentId'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupAssignmentId',
                'Required parameter "vehicleGroupAssignmentId" was null or undefined when calling vehicleGroupAssignmentsDeleteVehicleGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_group_assignments/{vehicle_group_assignment_id}`;
        urlPath = urlPath.replace('{vehicle_group_assignment_id}', encodeURIComponent(String(requestParameters['vehicleGroupAssignmentId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the vehicle group assignment with the given ID.
     * Delete a vehicle group assignment
     */
    async vehicleGroupAssignmentsDeleteVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsDeleteVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleGroupAssignmentsDeleteVehicleGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the vehicle group assignment with the given ID.
     * Delete a vehicle group assignment
     */
    async vehicleGroupAssignmentsDeleteVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsDeleteVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleGroupAssignmentsDeleteVehicleGroupAssignmentRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for vehicleGroupAssignmentsListVehicleGroupAssignments without sending the request
     */
    async vehicleGroupAssignmentsListVehicleGroupAssignmentsRequestOpts(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehicleGroupAssignmentsListVehicleGroupAssignments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['vehicleGroupIds'] != null) {
            queryParameters['vehicle_group_ids'] = requestParameters['vehicleGroupIds'];
        }

        if (requestParameters['vehicleId'] != null) {
            queryParameters['vehicle_id'] = requestParameters['vehicleId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_group_assignments/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the vehicle group assignment present.
     * List vehicle group assignment
     */
    async vehicleGroupAssignmentsListVehicleGroupAssignmentsRaw(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleGroupAssignment>>> {
        const requestOptions = await this.vehicleGroupAssignmentsListVehicleGroupAssignmentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VehicleGroupAssignmentFromJSON));
    }

    /**
     * Lists all the vehicle group assignment present.
     * List vehicle group assignment
     */
    async vehicleGroupAssignmentsListVehicleGroupAssignments(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleGroupAssignment>> {
        const response = await this.vehicleGroupAssignmentsListVehicleGroupAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleGroupAssignmentsListVehicleGroupAssignmentsMetadata without sending the request
     */
    async vehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRequestOpts(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehicleGroupAssignmentsListVehicleGroupAssignmentsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['vehicleGroupIds'] != null) {
            queryParameters['vehicle_group_ids'] = requestParameters['vehicleGroupIds'];
        }

        if (requestParameters['vehicleId'] != null) {
            queryParameters['vehicle_id'] = requestParameters['vehicleId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_group_assignments/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle group assignment listing metadata
     */
    async vehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRaw(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.vehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle group assignment listing metadata
     */
    async vehicleGroupAssignmentsListVehicleGroupAssignmentsMetadata(requestParameters: VehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.vehicleGroupAssignmentsListVehicleGroupAssignmentsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleGroupAssignmentsReadVehicleGroupAssignment without sending the request
     */
    async vehicleGroupAssignmentsReadVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsReadVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupAssignmentId'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupAssignmentId',
                'Required parameter "vehicleGroupAssignmentId" was null or undefined when calling vehicleGroupAssignmentsReadVehicleGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_group_assignments/{vehicle_group_assignment_id}`;
        urlPath = urlPath.replace('{vehicle_group_assignment_id}', encodeURIComponent(String(requestParameters['vehicleGroupAssignmentId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the vehicle group assignment specified by the given ID.
     * Get a single vehicle group assignment
     */
    async vehicleGroupAssignmentsReadVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsReadVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroupAssignment>> {
        const requestOptions = await this.vehicleGroupAssignmentsReadVehicleGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleGroupAssignmentFromJSON(jsonValue));
    }

    /**
     * Returns the vehicle group assignment specified by the given ID.
     * Get a single vehicle group assignment
     */
    async vehicleGroupAssignmentsReadVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsReadVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroupAssignment> {
        const response = await this.vehicleGroupAssignmentsReadVehicleGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleGroupAssignmentsUpdateVehicleGroupAssignment without sending the request
     */
    async vehicleGroupAssignmentsUpdateVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsUpdateVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupAssignmentId'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupAssignmentId',
                'Required parameter "vehicleGroupAssignmentId" was null or undefined when calling vehicleGroupAssignmentsUpdateVehicleGroupAssignment().'
            );
        }

        if (requestParameters['vehicleGroupAssignmentUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupAssignmentUpdate',
                'Required parameter "vehicleGroupAssignmentUpdate" was null or undefined when calling vehicleGroupAssignmentsUpdateVehicleGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_group_assignments/{vehicle_group_assignment_id}`;
        urlPath = urlPath.replace('{vehicle_group_assignment_id}', encodeURIComponent(String(requestParameters['vehicleGroupAssignmentId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleGroupAssignmentUpdateToJSON(requestParameters['vehicleGroupAssignmentUpdate']),
        };
    }

    /**
     * Update the vehicle group assignment specified by the given ID.
     * Update vehicle group assignment
     */
    async vehicleGroupAssignmentsUpdateVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsUpdateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleGroupAssignment>> {
        const requestOptions = await this.vehicleGroupAssignmentsUpdateVehicleGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleGroupAssignmentFromJSON(jsonValue));
    }

    /**
     * Update the vehicle group assignment specified by the given ID.
     * Update vehicle group assignment
     */
    async vehicleGroupAssignmentsUpdateVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsUpdateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleGroupAssignment> {
        const response = await this.vehicleGroupAssignmentsUpdateVehicleGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleGroupAssignmentsValidateCreateVehicleGroupAssignment without sending the request
     */
    async vehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupAssignmentCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupAssignmentCreate',
                'Required parameter "vehicleGroupAssignmentCreate" was null or undefined when calling vehicleGroupAssignmentsValidateCreateVehicleGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_group_assignments/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleGroupAssignmentCreateToJSON(requestParameters['vehicleGroupAssignmentCreate']),
        };
    }

    /**
     * Validate data for a new vehicle group assignment without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle group assignment
     */
    async vehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new vehicle group assignment without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle group assignment
     */
    async vehicleGroupAssignmentsValidateCreateVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleGroupAssignmentsValidateCreateVehicleGroupAssignmentRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignment without sending the request
     */
    async vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRequestOpts(requestParameters: VehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleGroupAssignmentId'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupAssignmentId',
                'Required parameter "vehicleGroupAssignmentId" was null or undefined when calling vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignment().'
            );
        }

        if (requestParameters['vehicleGroupAssignmentUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleGroupAssignmentUpdate',
                'Required parameter "vehicleGroupAssignmentUpdate" was null or undefined when calling vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_group_assignments/{vehicle_group_assignment_id}/validate`;
        urlPath = urlPath.replace('{vehicle_group_assignment_id}', encodeURIComponent(String(requestParameters['vehicleGroupAssignmentId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleGroupAssignmentUpdateToJSON(requestParameters['vehicleGroupAssignmentUpdate']),
        };
    }

    /**
     * Validate data for updating the given vehicle group assignment, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle group assignment update
     */
    async vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRaw(requestParameters: VehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given vehicle group assignment, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle group assignment update
     */
    async vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignment(requestParameters: VehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleGroupAssignmentsValidateUpdateVehicleGroupAssignmentRaw(requestParameters, initOverrides);
    }

}
